export class PopupRenderer {
  constructor(options = {}) {
    this.options = {
      popupContentProvider: null,
      loadErrorMessage: "Informatie kan niet worden geladen",
      moreInfoHtml: "Meer informatie",
      directPanel: false,
      debug: null,
      ...options
    };
  }

  async createPopupContent(item) {
    if (this.options.popupContentProvider) {
      // Use async content provider
      try {
        const customContent = await this.options.popupContentProvider(item);
        // Add More info link to custom content
        const moreInfoLink = `
          <div class="dw-map-popup__actions">
            <a href="#" class="dw-map-more-info-link dw-map-more-info-link--popup" data-item-id="${item.id || Math.random().toString(36).substr(2, 9)}">${this.options.moreInfoHtml || 'Meer informatie'}</a>
          </div>
        `;
        return customContent + moreInfoLink;
      } catch (error) {
        console.error('Popup content provider error:', error);
        return `<div class="dw-map-popup">${this.options.loadErrorMessage}</div>`;
      }
    } else {
      // Use default content
      return `
        <div class="dw-map-popup">
          <p>Geen definitie voor popup-gegevens</p>
        </div>
      `;
    }
  }

  async bindPopup(marker, item, panelRenderer = null) {
    if (this.options.directPanel) {
      // Direct panel mode - no popup, click opens/updates panel directly
      marker.on('click', async () => {
        if (panelRenderer) {
          await panelRenderer.showItemDetails(item);
        }
      });
    } else {
      // Traditional popup mode
      const popupContent = await this.createPopupContent(item);
      marker.bindPopup(popupContent);
      
      // If panel is already visible, update content when popup opens
      marker.on('popupopen', async () => {
        if (panelRenderer && panelRenderer.isVisible()) {
          await panelRenderer.showItemDetails(item);
        }
      });
    }
  }

  async bindGeoJsonPopup(layer, feature, panelRenderer = null) {
    if (this.options.directPanel) {
      // Direct panel mode - no popup, click opens/updates panel directly
      layer.on('click', async () => {
        if (panelRenderer) {
          await panelRenderer.showItemDetails(feature);
        }
      });
    } else {
      // Traditional popup mode
      const popupContent = await this.createPopupContent(feature);
      layer.bindPopup(popupContent);
      
      // If panel is already visible, update content when popup opens
      layer.on('popupopen', async () => {
        if (panelRenderer && panelRenderer.isVisible()) {
          await panelRenderer.showItemDetails(feature);
        }
      });
    }
  }
}
